@if (user?.app_state?.startConversation != null) {
  <div class="items animate__animated" [class.animate__zoomInDown]="flags?.state == 'in'" [class.animate__backOutUp]="flags?.state == 'send'">
    <div class="item">
      @if (to) {
        <button mat-button class="closeBtn" (click)="user.app_state.startConversation = null"><mat-icon>close</mat-icon></button>
      }
      <div class="question">
        <mat-icon>message</mat-icon><br />
        New Message
      </div>
      <br />
      <form [formGroup]="form" (ngSubmit)="clickAddPill()">
        <mat-form-field class="example-chip-list">
          <mat-chip-grid #chipList aria-label="Recipients">
            @for (recipient of recipients; track recipient) {
              <mat-chip-row
                [removable]="removable"
                (removed)="remove(recipient)">
                {{recipient?.first_name}} {{recipient?.last_name}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
            <input
              placeholder="Enter recipient/s"
              #recipientInput
              [formControl]="recipientCtrl"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event)">
          </mat-chip-grid>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selected($event)">
            @for (recipient of filteredRecipients | async; track recipient) {
              <mat-option [value]="recipient">
                {{recipient?.full_name}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <!-- <p *ngIf="popularRecipients?.length > 0">Near by</p>
        <button *ngFor="let recipient of popularRecipients|slice:0:10" mat-button type="button" class="pill" (click)="clickAddPill(recipient)">
          {{ recipient?.full_name }}
        </button> -->
        <br clear="all" />
      </form>
    </div>
    <div class="item">
      @if (recipients.length > 0) {
        <br />
        <form [formGroup]="form2" (ngSubmit)="sendMessage()">
          <mat-form-field>
            <textarea matInput placeholder="Message" (keyup)="activateBtn()" (change)="activateBtn()" type="text" class="form-control" formControlName="message" [ngClass]="{ 'is-invalid': flags.sfe && f2.invalid }">
            </textarea>
            @if (f2.message.hasError('serverError')) {
              <mat-error>
                <small>{{f2.message.errors.serverError}}</small>
              </mat-error>
            }
            @if (f2.message.hasError('message')) {
              <mat-error>
                <small>Message contains unallowed words.</small>
              </mat-error>
            }
          </mat-form-field>
        </form>
      }
    </div>
    @if (recipients.length > 0) {
      <button [disabled]="$safeNavigationMigration(flags?.btnAdding)" [class.btnReady2]="!flags?.btnAdding" mat-button color="primary" class="item" (click)="sendMessage()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    }
  </div>
}
